const menu = {
  key: "customerItemEquivalences",
  route: "/legacy/customer-item-equivalences",
  label: "sidebar.customerItemEquivalences",
  icon: "faLink",
  group: "sales",
  order: 23,
  permission: "legacy.customerItemEquivalences.read"
};

export default menu;